export default "__VITE_ASSET__BWDx2Bej__"